import { configureStore } from '@reduxjs/toolkit';
import statsReducer from './slices/statsSlice';
import packagesReducer from './slices/packagesSlice';
import dealerReducer from './slices/dealerSlice';

export const store = configureStore({
  reducer: {
    stats: statsReducer,
    packages: packagesReducer,
    dealer: dealerReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store; 